<template>
	<div class="user-content">
		<!-- 用户中心 -->
		<div class="box">
			<div v-if="!isDestroy" class="inner-box">
				<div class="title">
					个人中心
					<div class="icon-line"></div>
				</div>
				<div
					v-for="(item, index) in cardList"
					:key="index"
					class="info-box"
					:style="{
						marginBottom: index == cardList.length - 1 ? '0px' : ''
					}"
				>
					<div class="top">
						<div class="font">{{ item.title }}</div>
						<div class="btn">
							<a-button @click="openModal(item, index + 1)"
								>修改</a-button
							>
						</div>
					</div>
					<div class="bottom">{{ cardData[item.props] }}</div>
				</div>

				<a-button style="margin-top: 32px" danger @click="goDestroy"
					>注销账号</a-button
				>
			</div>
			<!-- icon -->
			<div v-if="isDestroy" class="status-img">
				<img src="@/assets/images/empty_5.png" alt="" />
				<div class="info">
					<div class="info-title">您的账户已注销</div>
					<div class="second-title">
						将在{{ second }}秒内返回登录页，轻舟期待与您再次相遇
					</div>
				</div>
			</div>
			<div class="versions">当前版本：V1.1</div>

			<!-- 弹窗 -->
			<a-modal
				v-model:open="modalData.visible"
				:title="modalData.title"
				@ok="handleOk"
			>
				<a-form
					:model="formState"
					name="basic"
					:label-col="{ span: 24 }"
					:wrapper-col="{ span: 24 }"
					autocomplete="off"
					ref="formRef"
				>
					<!-- 昵称 -->
					<a-form-item
						v-if="modalData.type == 1"
						label="昵称"
						name="nickname"
						:rules="[
							{
								required: true,
								message: '请输入昵称'
							}
						]"
					>
						<a-input
							placeholder="请输入昵称"
							v-model:value="formState.nickname"
							size="large"
						/>
					</a-form-item>

					<div v-if="modalData.type == 2" style="margin-bottom: 32px">
						<!-- 手机号 -->
						<a-form-item
							label="手机号"
							name="phone"
							:rules="[
								{
									required: true,
									message: '请输入手机号'
								}
							]"
						>
							<a-input-group compact>
								<a-select
									v-model:value="formState.phoneType"
									style="width: 86px"
									size="large"
								>
									<a-select-option value="'86'"
										>+86</a-select-option
									>
									<a-select-option value="xxx"
										>+xxx</a-select-option
									>
								</a-select>
								<a-input
									v-model:value="formState.phone"
									style="width: calc(100% - 86px)"
									placeholder="请输入手机号"
									size="large"
								/>
							</a-input-group>
						</a-form-item>
						<a-form-item
							label="验证码"
							name="code"
							:rules="[
								{
									required: true,
									message: '请输入验证码'
								}
							]"
						>
							<a-input-group compact>
								<a-input
									v-model:value="formState.code"
									style="width: 75%"
									placeholder="请输入验证码"
									size="large"
								/>
								<a-button
									type="primary"
                                    class="large-btn"
									style=""
									@click="sendCode"
                                    size="large"
									>发送验证码</a-button
								>
							</a-input-group>
						</a-form-item>
					</div>

					<!-- 密码 -->
					<div v-if="modalData.type == 3" style="margin-bottom: 32px">
						<a-form-item
							label="原密码"
							name="ex"
							:rules="[
								{
									required: true,
									message: '请输入原密码'
								}
							]"
						>
							<a-input
								placeholder="请输入原密码"
								v-model:value="formState.ex"
								size="large"
							/>
						</a-form-item>
						<a-form-item
							label="新密码"
							name="newPass"
							:rules="[
								{
									required: true,
									validator: validatornewPwd
								}
							]"
						>
							<a-input
								placeholder="8-20位大小写字母和数字组合"
								v-model:value="formState.newPass"
								size="large"
							/>
						</a-form-item>
						<a-form-item
							label="确认新密码"
							name="now"
							:rules="[
								{
									required: true,
									validator: validatorAgainPwd
								}
							]"
						>
							<a-input
								placeholder="8-20位大小写字母和数字组合"
								v-model:value="formState.now"
								size="large"
							/>
						</a-form-item>
					</div>
				</a-form>

				<template #footer>
					<a-button size="large" @click="cancelEdit">取消</a-button>
					<a-button type="primary" size="large" @click="handleOk"
						>确定</a-button
					>
				</template>
			</a-modal>

			<!-- 注销账号弹窗 -->
			<a-modal
				v-model:open="destroyVisible"
				title="注销账号"
				width="620px"
				wrapClassName="destroy"
				:centered="true"
			>
				<template #footer>
					<div class="btns">
						<a-button @click="cancelDestroy">取消</a-button>
						<a-button danger type="primary" @click="sureDestroy"
							>确定注销</a-button
						>
					</div>
				</template>
				<div class="destroy-box">
					<div class="line-title">
						注销账号是不可恢复的操作，请您确认：
					</div>
					<div class="line">
						1、注销后，您将无法登录、使用本账号。
					</div>
					<div class="line">
						2、您的以下信息将被清空且无法找回：身份信息、账号信息、所有使用记录，包括不限于项目信息、负载数据、测算参数配置、测算报告等。
					</div>
					<div class="line">
						3、您的分享链接将全部失效，他人无法查看您曾生成的任何测算报告。
					</div>
				</div>
				<div class="tips">
					点击下方“确定注销”按钮，即代表您已阅读并同意以上内容
				</div>
			</a-modal>
		</div>
	</div>
</template>

<script setup>
	import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
	import { useRouter } from "vue-router";
	const router = useRouter();
	import { message } from "ant-design-vue";
	// 引入vuex
	import { useStore } from "vuex";
	const store = useStore();
	// 引入api
	import {
		updateUserName,
		updatePhone,
		updatePassword,
		getVerifyCode,
		userDestroy
	} from "@/api/users.js";

	// 校验规则
	const reg = /(?=\S*\d)(?=\S*[a-z])(?=\S*[A-Z])^[\S]{8,20}$/;

	const cardList = ref([
		{
			title: "昵称",
			props: "nickname"
		},
		{
			title: "手机号",
			props: "phone"
		},
		{
			title: "密码",
			props: "password"
		}
	]);
	const cardData = ref({
		nickname: undefined,
		phone: undefined,
		code: undefined,
		password: undefined
	});

	/* 表单 */
	const formState = reactive({});
	const formRef = ref();

	/* 弹窗数据 */
	const modalData = ref({
		visible: false,
		title: "修改昵称",
		type: 1
	});

	// 销毁弹窗
	const destroyVisible = ref(false);
	const isDestroy = ref(false);
	const second = ref(5);
	const timer = ref(null);

	/* 打开弹窗 */
	const openModal = (item, index) => {
		modalData.value = {
			visible: true,
			title: `修改${item.title}`,
			type: index
		};

		if (index == 1) {
			formState.nickname = cardData.value.nickname;
		}
		if (index == 2) {
			formState.phone = cardData.value.phone;
			formState.code = undefined;
			formState.phoneType = "86";
		}
	};

	//  发送验证码
	const sendCode = () => {
		getVerifyCode({
			phone: formState.phone,
			type: 2
		}).then(res => {
			if (res) {
				message.success("验证码发送成功，请注意查收");
			}
		});
	};

	/* ok */
	const handleOk = () => {
		//
		// 校验form表单
		formRef.value.validate().then(datas => {
			// 判断弹窗类型
			switch (modalData.value.type) {
				case 1:
					updateUserName(datas).then(res => {
						handleResponseData(res, "修改昵称成功！", "nickname");
					});
					break;
				case 2:
					updatePhone(datas).then(res => {
						handleResponseData(
							res,
							"修改手机号成功，即将返回登录页！"
						);
					});
					break;
				case 3:
					delete datas.newPass;
					updatePassword(datas).then(res => {
						handleResponseData(
							res,
							"修改密码成功，即将返回登录页！"
						);
					});
					break;

				default:
					break;
			}
		});
	};

	/* cancel */
	const cancelEdit = () => {
		modalData.value.visible = false;
	};

	// 处理返回数据
	const handleResponseData = (res, msg, attribute = undefined) => {
		if (res) {
			message.success(msg);
			modalData.value.visible = false;

			if (attribute) {
				// 更新vuex中的值
				store.commit("upDateUserInfo", {
					...store.state.userInfo,
					nickname: formState.nickname
				});
				cardData.value.nickname = formState.nickname;
			} else {
				router.replace("/login");
			}
		}
	};

	// 前往注销页
	const goDestroy = () => {
		destroyVisible.value = true;

		// router.push("/destroy");
	};

	/* 密码校验 */
	const validatornewPwd = (rule, value, callback) => {
		if (reg.test(value)) {
			callback();
		} else {
			callback("8-20位大小写字母和数字组合");
		}
		formRef.value.validateFields(["now"]);
	};

	const validatorAgainPwd = (rule, value, callback) => {
		let newPwd = formState.newPass;
		if (value !== newPwd) {
			callback("两次密码不一致！");
		} else {
			if (reg.test(value)) {
				callback();
			} else {
				callback("8-20位大小写字母和数字组合");
			}
		}
	};

	// 取消注销
	const cancelDestroy = () => {
		destroyVisible.value = false;
	};

	// 确定注销
	const sureDestroy = () => {
		userDestroy().then(res => {
			if (res) {
				destroyVisible.value = false;
				isDestroy.value = true;
				second.value = 5;
				if (second.second === 0) {
					clearInterval(timer);
					timer = null;
				}
				store.commit("upDateUserInfo", {});
				timer.value = setInterval(() => {
					second.value = second.value - 1;
					if (second.value === 0) {
						router.replace("/login");
					}
				}, 1000);
			}
		});
	};

	onBeforeUnmount(() => {
		clearInterval(timer.value);
		timer.value = null;
		// 更新store中的breadcrumb信息
		store.commit("updateBreadCrumbInfo", null);
	});

	onMounted(() => {
		if (store.state.userInfo) {
			cardData.value = {
				...store.state.userInfo,
				password: "**************"
			};
		}
		// 更新store中的breadcrumb信息
		store.commit("updateBreadCrumbInfo", {
			title: "个人中心"
		});
	});
</script>

<style lang="less" scoped>
	.user-content {
		// width: 100%;
		height: calc(100%);
		padding: 24px 0 24px 0;
		// position: relative;
		// height: calc(100vh - 64px);

		.box {
			width: 100%;
			height: calc(100vh - 164px);
			background: #ffffff;
			border: 1px solid #dbe0e8;
			border-radius: 4px;
			padding-top: 82px;
			position: relative;

			display: flex;
			justify-content: center;
			flex-wrap: wrap;

			.inner-box {
				width: 60%;
				.title {
					position: relative;
					padding-bottom: 8px;
					.icon-line {
						position: absolute;
						width: 75px;
						height: 0;
						border-bottom: 5px solid #0058fc;
						border-left: 5px solid transparent;
						border-right: 5px solid transparent;
						border-radius: 30px;
						bottom: 0;
					}
				}

				.info-box {
					width: 100%;
					border-bottom: 1px solid rgba(0, 0, 0, 0.16);
					margin-bottom: 48px;
					position: relative;

					.top {
						.font {
							height: 26px;
							opacity: 0.85;
							font-family: PingFangSC-Medium;
							font-weight: 600;
							font-size: 16px;
							color: #000000;
							letter-spacing: 0;
							line-height: 26px;
							margin-bottom: 6px;
						}

						.btn {
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							right: 0;
							z-index: 999;
						}
					}

					.bottom {
						opacity: 0.65;
						font-family: PingFangSC-Regular;
						font-weight: 400;
						font-size: 16px;
						color: #000000;
						letter-spacing: 0;
						padding-bottom: 6px;
						padding-top: 6px;
					}
				}
			}

			// 公共样式
			// .status-img {
			// 	position: absolute;
			// 	top: 126px;
			// 	left: 50%;
			// 	transform: translateX(-50%);
			// 	display: flex;
			// 	flex-wrap: wrap;
			// 	justify-content: center;
			// 	img {
			// 		width: 240px;
			// 		height: 240px;
			// 	}

			// 	.info {
			// 		width: 100%;
			// 		margin-top: 12px;
			// 		&-title {
			// 			height: 28px;
			// 			font-family: PingFangSC-Medium;
			// 			font-weight: 600;
			// 			font-size: 18px;
			// 			color: #000000;
			// 			letter-spacing: 0;
			// 			line-height: 28px;
			// 			text-align: center;
			// 		}

			// 		.second-title {
			// 			height: 22px;
			// 			font-family: PingFangSC-Regular;
			// 			font-weight: 400;
			// 			font-size: 14px;
			// 			color: #000000;
			// 			letter-spacing: 0;
			// 			line-height: 22px;
			// 			margin-top: 4px;
			// 			text-align: center;
			// 		}
			// 	}
			// }
			.versions {
				position: absolute;
				bottom: 24px;
				left: 50%;
				transform: translateX(-50%);
				height: 24px;
				opacity: 0.65;
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 16px;
				color: #000000;
				letter-spacing: 0;
				text-align: center;
				line-height: 24px;
			}

			.title {
				font-size: 18px;
				font-weight: bold;
				border-bottom: 1px solid #00000029;
				padding-bottom: 6px;
				margin-bottom: 40px;
			}
		}
	}

	.destroy {
		.destroy-box {
			width: 100%;
			height: 196px;
			background: #e9eff633;
			border: 1px solid #a2abbb66;
			border-radius: 4px;
			padding: 24px;

			.line-title {
				height: 24px;
				opacity: 0.85;
				font-family: PingFangSC-Medium;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				letter-spacing: 0;
				text-align: justify;
				line-height: 24px;
				margin-bottom: 12px;
			}
			.line {
				line-height: 24px;
				opacity: 0.85;
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 16px;
				color: #000000;
				letter-spacing: 0;
				text-align: justify;
				margin-bottom: 6px;
			}
		}
		.tips {
			width: 100%;
			height: 22px;
			opacity: 0.65;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
			letter-spacing: 0;
			line-height: 22px;
			text-align: right;
			margin-top: 24px;
		}
		.btns {
			button {
				width: 96px;
				height: 40px;
				border-radius: 4px;
				margin-left: 12px;
			}
		}
	}


    .large-btn{
        width: 25%;
        // border-top-left-radius: unset;
    }
</style>
